
const defaultColor = "#1e6ee6";
const defaultMarkTextColor = "#222222";
const defaultFontSize = 10;
const defaultStrokeWidth = 1;

export {
    defaultColor,
    defaultMarkTextColor,
    defaultFontSize,
    defaultStrokeWidth,
}